import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_Toast = _resolveComponent("Toast")
  const _component_RouterView = _resolveComponent("RouterView")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, { position: "bottom-center" }),
    _createElementVNode("main", null, [
      _createVNode(_component_RouterView)
    ])
  ], 64))
}